import { render, staticRenderFns } from "./shopheaderMobile.vue?vue&type=template&id=ec4f9572&scoped=true"
import script from "./shopheaderMobile.vue?vue&type=script&lang=js"
export * from "./shopheaderMobile.vue?vue&type=script&lang=js"
import style0 from "./shopheaderMobile.vue?vue&type=style&index=0&id=ec4f9572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4f9572",
  null
  
)

export default component.exports